const IGNORED_HTTP_STATUSES = new Set([401, 403, 404]);
const getNumberProperty = (value, property) => {
    if (value &&
        typeof value === "object" &&
        property in value &&
        typeof value[property] === "number") {
        return value[property];
    }
    return undefined;
};
const getResponseStatus = (error) => {
    if (error instanceof Response) {
        return error.status;
    }
    if (!error || typeof error !== "object" || !("response" in error)) {
        return undefined;
    }
    const response = error.response;
    if (response instanceof Response) {
        return response.status;
    }
    return getNumberProperty(response, "status");
};
const getErrorStatus = (error) => getResponseStatus(error) ?? getNumberProperty(error, "status");
export const beforeSend = (event, hint) => {
    const status = getErrorStatus(hint.originalException);
    if (status !== undefined && IGNORED_HTTP_STATUSES.has(status))
        return null;
    return event;
};
